<template>
  <ul class='poi-categories' role="menu" aria-label="Poi's category list">
    <category-block v-for="(category, index) in tourCategories" :key="index" :category="category"/>
  </ul>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import CategoryBlock from './CategoryBlock'

export default {
  name: 'CategoryList',
  components: {
    CategoryBlock
  },
  created () {
    this.getCategories()
  },
  computed: mapState('personalized', {
    tourCategories: state => state.categoriesList
  }),
  methods: mapActions('personalized', ['getCategories'])
}
</script>

<style lang="stylus">
  .curated-tour
    .content
      .description
        padding 15px 13px 13px
      .poi-categories
        list-style none
        padding 0
</style>
